import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
  FETCH_NEW_BOOKINGS_SUCCESS,
  FETCH_ORDER_LIST_QUEUE,
  FETCH_ORDER_LIST_QUEUE_SUCCESS,
  FETCH_ORDER_LIST_QUEUE_FAILED
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push, update, query, orderByChild, equalTo } from "firebase/database";
import { Platform } from 'react-native';

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef } = firebase;
  
  const uid = auth.currentUser?.uid;
  if (!uid) return;

  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });
  onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .map((i) => {
          data[i].id = i;
          return data[i];
        });
      const userInfo = store.getState().auth.profile;
      let heatpoints = [];
      let bookings = Object.values(snapshot.val());
      for (let i = 0; i < bookings.length; i++) {
        if (bookings[i].status == 'NEW' && ((userInfo.hasOwnProperty('carType') && userInfo.carType === bookings[i].carType) || !userInfo.hasOwnProperty('carType'))) {
          // Ensure latitude and longitude are numbers, not strings
          const lat = parseFloat(bookings[i].pickup.lat);
          const lng = parseFloat(bookings[i].pickup.lng);
          
          // Only add if valid numbers
          if (!isNaN(lat) && !isNaN(lng)) {
            heatpoints.push({ 
              latitude: lat, 
              longitude: lng, 
              weight: 1 
            });
          }
        }
      }
      dispatch({
        type: FETCH_NEW_BOOKINGS_SUCCESS,
        payload: heatpoints
      });

      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  });
};

export const acceptTask = (task) => (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef, carAddRef } = firebase;

  const uid = auth.currentUser.uid;

  // Prevent multiple executions for the same task
  if (acceptTask.processing && acceptTask.processing.has(task.id)) {
    console.log('🚫 Task already being processed:', task.id);
    return;
  }

  // Initialize processing set if not exists
  if (!acceptTask.processing) {
    acceptTask.processing = new Set();
  }

  // Add task to processing set
  acceptTask.processing.add(task.id);
  console.log('🚗 Starting acceptTask for booking:', task.id);

  onValue(singleUserRef(uid), (snapshot) => {
    let profile = snapshot.val();

    console.log(['PROFILE ======>', profile]);
    console.log('🔍 Vehicle fields in profile:', {
      vehicleNumber: profile?.vehicleNumber || 'undefined',
      vehicleYear: profile?.vehicleYear || 'undefined',
      vehicleColor: profile?.vehicleColor || 'undefined',
      carType: profile?.carType || 'undefined'
    });
    
    // Validate profile data
    if (!profile) {
      console.error('❌ Profile is null or undefined');
      // Remove task from processing set
      if (acceptTask.processing) {
        acceptTask.processing.delete(task.id);
      }
      return;
    }

    runTransaction(singleBookingRef(task.id), (booking) => {
      if (!booking) {
        console.error('❌ Booking not found:', task.id);
        return null;
      }

      let fleetCommission_fee = profile.fleetadmin ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees || 0)) * parseFloat(booking.fleet_admin_comission || 0) / 100).toFixed(2) : 0;
      let driver_fee = parseFloat(parseFloat(booking.estimate) - (parseFloat(booking.convenience_fees || 0) + parseFloat(fleetCommission_fee))).toFixed(2);
      
      // Allow driver to accept booking if:
      // 1. Has requestedDrivers (existing flow)
      // 2. Status is NEW or ADMIN_QUEUE (direct acceptance)
      if (booking && (booking.requestedDrivers || booking.status === 'NEW' || booking.status === 'ADMIN_QUEUE')) {
        console.log('✅ Driver can accept this booking:', {
          hasRequestedDrivers: !!booking.requestedDrivers,
          status: booking.status,
          bookingId: task.id
        });
        
        booking.driver = uid;
        booking.driver_image = (profile && profile.profile_image) ? profile.profile_image : "";
        booking.car_image = (profile && profile.car_image) ? profile.car_image : "";
        booking.driver_name = (profile && profile.firstName && profile.lastName) ? (profile.firstName + " " + profile.lastName) : "";
        booking.driver_contact = (profile && profile.mobile) ? profile.mobile : "";
        booking.driver_token = (profile && profile.pushToken) ? profile.pushToken : '';
        
        // Get vehicle data from profile (fallback) with safe access
        let vehicleData = {
          vehicleNumber: (profile && profile.vehicleNumber) ? profile.vehicleNumber : "",
          vehicleYear: (profile && profile.vehicleYear) ? profile.vehicleYear : "",
          vehicleColor: (profile && profile.vehicleColor) ? profile.vehicleColor : "",
          carType: (profile && profile.carType) ? profile.carType : "",
          vehicleMake: (profile && profile.vehicleMake) ? profile.vehicleMake : "",
          vehicleModel: (profile && profile.vehicleModel) ? profile.vehicleModel : ""
        };
        
        console.log('🚗 Using vehicle data from profile for transaction');
        
        // Set initial data from profile
        booking.vehicle_number = vehicleData.vehicleNumber;
        booking.vehicleYear = vehicleData.vehicleYear;
        booking.vehicleColor = vehicleData.vehicleColor;
        booking.carType = vehicleData.carType;
        booking.vehicleMake = vehicleData.vehicleMake;
        booking.vehicleModel = vehicleData.vehicleModel;
        booking.vehicleNumber = vehicleData.vehicleNumber;
        booking.driverRating = profile.rating ? profile.rating : "0";
        booking.fleetadmin = (profile && profile.fleetadmin) ? profile.fleetadmin : "";
        booking.driver_share = driver_fee;
        booking.fleetCommission = (profile && profile.fleetadmin) ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees || 0)) * parseFloat(booking.fleet_admin_comission || 0) / 100).toFixed(2) : null;
        booking.status = "ACCEPTED";
        booking.driverDeviceId = task.driverDeviceId ? task.driverDeviceId : null;
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        
        // Clear auto search related fields when driver accepts
        booking.autoSearchActive = null;
        booking.autoSearchTimestamp = null;
        booking.automaticSearch = null;
        booking.cancelledBy = null;
        booking.cardPaymentAmount = null;
        booking.cashPaymentAmount = null;
        booking.discount = null;
        booking.dropAdress = null;
        booking.id = null;
        booking.pickupAddress = null;
        booking.previousDriver = null;
        booking.previousDriverToken = null;
        booking.reason = null;
        booking.wasAccepted = null;
        
        // Add acceptance timestamp and method
        booking.accepted_at = new Date().toISOString();
        booking.accepted_by = 'driver';
        booking.acceptance_method = 'direct';
        
        console.log('✅ Booking updated for driver acceptance, status changed to ACCEPTED');
        return booking;
      } else {
        // Handle case when driver cannot accept this booking
        console.log('⚠️ Driver cannot accept this booking:', {
          hasBooking: !!booking,
          hasRequestedDrivers: !!(booking && booking.requestedDrivers),
          status: booking ? booking.status : 'undefined',
          bookingId: task.id
        });
        return null; // Return null to indicate failure
      }
    })
    .then((result) => {
      if (result) {
        console.log('✅ Transaction completed successfully');
        
        // Update booking with fresh car data after transaction
        if (firebase && firebase.carAddRef) {
          get(firebase.carAddRef).then((carSnapshot) => {
          if (carSnapshot.exists()) {
            const cars = carSnapshot.val();
            Object.keys(cars).forEach(carId => {
              const car = cars[carId];
              if (car.driver === uid && car.active) {
                console.log('🚗 Found active car in cars node, updating booking:', car);
                // Update booking with fresh car data
                update(singleBookingRef(task.id), {
                  vehicleYear: car.vehicleYear || "",
                  vehicleColor: car.vehicleColor || "",
                  carType: car.carType || "",
                  vehicleMake: car.vehicleMake || "",
                  vehicleModel: car.vehicleModel || "",
                  vehicleNumber: car.vehicleNumber || ""
                });
              }
            });
          }
          }).catch(error => {
            console.log('⚠️ Error reading cars data:', error);
          });
        }
        
        // Verify the booking was updated and proceed
        get(singleBookingRef(task.id))
          .then((snapshot) => {
            if (!snapshot.exists()) {
              console.error('❌ Booking not found after transaction:', task.id);
              return;
            } else {
              let requestedDrivers = snapshot.val() && snapshot.val().requestedDrivers;
              let driverId = snapshot.val() && snapshot.val().driver;

              if (requestedDrivers == undefined && driverId === uid) {
                console.log('✅ Driver successfully assigned to booking, updating profile...');
                
                updateProfile({ queue: snapshot.val().category === "delivery" ? false : true })(dispatch);
                
                if (task.customer_token) {
                  RequestPushMsg(task.customer_token, {
                    title: store.getState().languagedata.defaultLanguage.notification_title,
                    msg: (profile && profile.firstName ? profile.firstName : 'Driver') + 
                         store.getState().languagedata.defaultLanguage.accept_booking_request,
                    screen: "BookedCab",
                    params: { bookingId: task.id },
                    channelId: 'general',
                    sound: Platform.OS === 'android' ? 'general' : 'general.mp3'
                  });
                }

                const driverLocation = store.getState().gpsdata.location;
                console.log("🎯 Driver accepted task - saving initial tracking");
                console.log("🎯 Task ID:", task.id);
                console.log("🎯 Driver location:", driverLocation);

                const trackingData = {
                  at: new Date().getTime(),
                  status: "ACCEPTED",
                  lat: driverLocation.lat,
                  lng: driverLocation.lng,
                };
                
                console.log("💾 Saving initial ACCEPTED tracking:", trackingData);
                push(trackingRef(task.id), trackingData);

                dispatch({
                  type: ACCEPT_TASK,
                  payload: { task: task },
                });
                
                // Remove task from processing set
                if (acceptTask.processing) {
                  acceptTask.processing.delete(task.id);
                  console.log('✅ Task removed from processing set:', task.id);
                }
                
                console.log('🎉 Order accepted successfully! Status changed to ACCEPTED');
              } else {
                console.log('⚠️ Driver assignment verification failed:', {
                  requestedDrivers: requestedDrivers,
                  driverId: driverId,
                  uid: uid
                });
              }
            }
          })
          .catch((error) => {
            console.error('❌ Error verifying booking after transaction:', error);
          });
      } else {
        console.error('❌ Transaction failed - booking could not be updated');
        // Remove task from processing set on failure
        if (acceptTask.processing) {
          acceptTask.processing.delete(task.id);
          console.log('❌ Task removed from processing set due to transaction failure:', task.id);
        }
      }
    })
    .catch((error) => {
      console.error('❌ Error in acceptTask transaction:', error);
      
      // Remove task from processing set on error
      if (acceptTask.processing) {
        acceptTask.processing.delete(task.id);
        console.log('❌ Task removed from processing set due to error:', task.id);
      }
    });
  }, { onlyOnce: true });
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  runTransaction(singleBookingRef(bookingId), (booking) => {
    if (booking && booking.requestedDrivers) {
      if (
        booking.requestedDrivers !== null &&
        Object.keys(booking.requestedDrivers).length === 1
      ) {
        booking.status = "NEW";
        booking.requestedDrivers = null;
        booking.driverEstimates = null;
        if (booking.customer_token) {
          RequestPushMsg(booking.customer_token, {
            title:
              store.getState().languagedata.defaultLanguage.notification_title,
            msg:
              store.getState().languagedata.defaultLanguage.booking_cancelled +
              bookingId,
            screen: "BookedCab",
            params: { bookingId: bookingId },
            channelId: 'general',
            sound: Platform.OS === 'android' ? 'general' : 'general.mp3' // Correct format for each platform
          });
        }
        dispatch({
          type: CANCEL_TASK,
          payload: { uid: uid, bookingId: bookingId },
        });
      } else {
        delete booking.requestedDrivers[uid];
      }
      if (booking.driverOffers && booking.driverOffers[uid]) {
        delete booking.driverOffers[uid];
      }
      if (booking.selectedBid && booking.selectedBid.driver === uid) {
        delete booking.selectedBid;
      }
      return booking;
    }
  });
};

export const fetchOrderListQueue = () => async (dispatch) => {
  const { bookingRef } = firebase;
  
  dispatch({
    type: FETCH_ORDER_LIST_QUEUE,
    payload: null,
  });

  try {
    console.log("🔍 Fetching orders for driver queue...");
    
    // Get all bookings with ADMIN_QUEUE status (no driver assigned)
    const adminQueueQuery = query(
      bookingRef,
      orderByChild('status'),
      equalTo('ADMIN_QUEUE')
    );
    
    const adminQueueSnapshot = await get(adminQueueQuery);
    let adminQueueOrders = [];
    
    if (adminQueueSnapshot.exists()) {
      const adminQueueData = adminQueueSnapshot.val();
      adminQueueOrders = Object.keys(adminQueueData)
        .filter(key => !adminQueueData[key].driver) // Only orders without driver
        .map(key => ({
          ...adminQueueData[key],
          id: key,
          source: 'admin_queue'
        }));
      console.log("🔍 Found admin queue orders:", adminQueueOrders.length);
    }

    // Get all bookings with NEW status (no driver assigned)
    const newOrdersQuery = query(
      bookingRef,
      orderByChild('status'),
      equalTo('NEW')
    );
    
    const newOrdersSnapshot = await get(newOrdersQuery);
    let newOrders = [];
    
    if (newOrdersSnapshot.exists()) {
      const newOrdersData = newOrdersSnapshot.val();
      newOrders = Object.keys(newOrdersData)
        .filter(key => !newOrdersData[key].driver) // Only orders without driver
        .map(key => ({
          ...newOrdersData[key],
          id: key,
          source: 'new_order'
        }));
      console.log("🔍 Found new orders:", newOrders.length);
    }

    // Combine both order types
    const allOrders = [...adminQueueOrders, ...newOrders];
    console.log("🔍 Total available orders:", allOrders.length);

    dispatch({
      type: FETCH_ORDER_LIST_QUEUE_SUCCESS,
      payload: allOrders,
    });
    
  } catch (error) {
    console.error('Error fetching order list queue:', error);
    dispatch({
      type: FETCH_ORDER_LIST_QUEUE_FAILED,
      payload: error.message
    });
  }
};
